module.exports = require("../../support/isExpired");
